"use client";

import { useEffect, useRef } from "react";
import { trackViewItemList, type AnalyticsItem } from "@/lib/analytics";

type Props = { listName: string; items: AnalyticsItem[] };

/** Liste görüntüleme — sayfa/filtre değişiminde bir kez view_item_list ateşler. */
export function ItemListTracker({ listName, items }: Props) {
  const key = `${listName}:${items.map((i) => i.id).join(",")}`;
  const fired = useRef<string | null>(null);
  useEffect(() => {
    if (fired.current === key || items.length === 0) return;
    fired.current = key;
    trackViewItemList(listName, items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return null;
}
